/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
// import { useEnvStore } from '../env';

import { useNavigate } from 'react-router-dom';
import { useAppStore } from '.';

/*
 * This hook will launch authenticated requests  
 * It ensures token is available 
 * 
 */

function useApp (p) {
    // const env = useEnvStore();
    const app = useAppStore();
    const navigate = useNavigate();
    
    function goto (page) {
        app.goto(page)
    }

    useEffect(() => {
        window.onpopstate = (e) => {
            e.preventDefault();
            e.stopPropagation();
            app.goback(e);
        };
 
        return () => {
            window.onpopstate = () => {};
        };
    }, [navigate]);

    useEffect(() => {
        app.navigate = navigate;
        app.initGTAG();
        app.env.initApp();
        app.page = '';
        app.widgetPath = app.env.page.completePath;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return {
        appStore: app,
        goto,
    };
}

export default useApp;